<template>
  <div class="content-wrapper">
    <vs-row class="my-4">
      <vs-col vs-lg="8" vs-sm="12">
        <vs-button :to="`users/invite`" color="primary" type="filled"
          >Add New</vs-button
        >
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12">
        <div style="float:right;">
          <vs-input
            id="search"
            class="inputx"
            placeholder="Search..."
            v-model="search"
            v-on:input="debounceInput"
          />
        </div>
      </vs-col>
    </vs-row>

    <vs-card>
      <b-table
        ref="table"
        style="min-height: 600px;"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height:600px;">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>
        <template v-slot:cell(role)="data">{{ data.item.role }}</template>

        <template v-slot:cell(action)="data">
          <vs-button @click="open(data.item)" color="primary" type="flat"
            >View</vs-button
          >
        </template>
      </b-table>

      <div class="mt-3 text-right">
        <vs-pagination
          :total="Math.ceil(totalRows / 30)"
          v-model="currentPage"
          prev-icon="arrow_back"
          next-icon="arrow_forward"
        ></vs-pagination>

        <div class="mt-3">{{ from }} to {{ to }} of {{ totalRows }} items</div>
      </div>
    </vs-card>
  </div>
</template>
<script>
import Service from "../../../services";
export default {
  components: {},
  data: () => ({
    remarkDialog: false,
    isBusy: false,
    currentPage: 1,
    perPage: 30,
    totalRows: 0,
    selected: [],
    search: "",
    filter: "",
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    columns: [
      { label: "Name", key: "name", sortable: false },
      { label: "Email", key: "email", sortable: false },
      { label: "Role", key: "role", sortable: false }
    ],
    stats: null
  }),
  watch: {
    currentPage: {
      handler: function(val, oldVal) {
        if (oldVal != val) {
        }
      }
    },
    search: {
      handler: function(val, oldVal) {
        if (oldVal != val) {
          this.checkSearchStr(val);
        }
      }
    }
  },
  mounted() {
    window.addEventListener("keydown", e => {
      if (
        this.remarkDialog == false &&
        this.extendDialog == false &&
        this.resendDialog == false
      ) {
        if (!event.target.matches('[id="search"]')) {
          //backspace
          if (e.which == 27 || e.which == 8) {
            let s = this.search.substring(0, this.search.length - 1);
            this.search = s;
          } else if (
            e.ctrlKey ||
            e.altKey ||
            e.shiftKey ||
            e.which == 9 ||
            e.which == 91 ||
            (e.which >= 112 && e.which <= 123)
          ) {
          } else {
            this.search += String.fromCharCode(e.keyCode);
          }
          return;
        }
      }
    });
  },
  created() {
    Service.Event.get(this.$route.query.e)
      .then(res => {
        if (res.success) {
          let data = {
            merchant_id: res.data.event.merchant_id,
            biz: "ev",
            x: res.data.event.event_id
          };

          let header = {
            slug: res.data.event.e,
            title: res.data.event.pro_name,
            excerpt: res.data.event.date,
            image: res.data.event.merchant.logo,
            action: "openEventList"
          };
          this.$store.dispatch("Utility/setHeader", header);
        }
      })
      .catch(e => {
        /* this.$router.push("/pages/error-404").catch(() => {}); */
      });
  },
  methods: {
    debounceInput: _.debounce(function(e) {
      this.filter = e;
      this.search = e;
    }, 500),
    checkSearchStr: _.debounce(function(val) {
      this.filter = val;
      this.$refs.table.refresh();
    }, 500),
    dataProvider(ctx, callback) {
      this.isBusy = true;

      setTimeout(() => {
        let data = {
          e: this.$route.query.e
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map(key => key + "=" + ctx[key])
            .join("&");

        Service.Merchant.get_users(this.$route.query.s, params)
          .then(res => {
            this.isBusy = false;
            this.totalRows = res.data.total;
            this.from = res.data.from;
            this.to = res.data.to;
            this.data = res.data.rows;
            /*
          this.data = res.data.rows.map(item => {
            let found = item.role.biz.ev.find(x => x.e == this.$route.query.e);
            return { ...item, role: found.role };
          });
          */

            //this.log = res.log;
            //this.lagacy_query = res.lagacy_query;
            callback(this.data);
          })
          .catch(error => {
            console.log(error);
            // Here we could override the busy state, setting isBusy to false
            // this.isBusy = false
            // Returning an empty array, allows table to correctly handle
            // internal busy state in case of error
            //return [];
            callback([]);
          });
      }, 500);
    },
    open(item) {
      this.$router.push("/users/" + item.id + "/view");
    }
  }
};
</script>
